export default __webpack_public_path__ + "static/iphones-32afdf07c64033cdf07a917e3dc2c3cc.png";